survey: 診断
engagement:
  survey: エンゲージメント診断
explanation: TERAS は株式会社スタメンが提供するエンゲージメント診断です。
page:
  notFound: お探しのページは見つかりませんでした。
  invalid: URLが正しく入力されていないか、
  deleted: このページが削除された可能性があります。
start: はじめる
next: 次に進む
prev: 前へ戻る
confirm: 確定する
questions: 質問
answers: 回答
all: は以上です。
finished: は完了しました。
closed: は終了しました。
good.job: お疲れ様でした。
thanks: ご回答いただきありがとうございました。
surveyError:
  flash: ログインに失敗しました。
  title: タイムアウトしました
  message:
    line1: セッションの有効期限が切れたため、
    line2: 認証が完了できませんでした。
  callout:
    title: 以下の手順で再度お試しください
    step1: サーベイのリンクをもう一度開いてください。
    step2: 「TUNAGにログインする」を押して、もう一度ログインしてください。
  note:
    line1: ※ このページからは直接サーベイに戻ることができません。
    line2: お手元のサーベイリンク（メール・チャット等）から再度アクセスしてください。
authGate:
  loginSuccess: ログインが完了しました。
  message:
    line1: このサーベイを開始するには、
    line2: TUNAG アカウントでのログインが必要です。
  button: TUNAGにログインする

authError:
  flash:
    denied: 連携が拒否されました。
    failed: 連携に失敗しました。
    loadError: 読み込みに失敗しました。
  denied:
    title: 連携が拒否されました
    message: サーベイを開始するには、TUNAGとの連携が必要です。
  failed:
    title: 連携に失敗しました
    message: お手数ですが、もう一度お試しください。
  loadError:
    title: 読み込みに失敗しました
    message: お手数ですが、再読み込みしてください。
  retry: もう一度ログインする
  reload: 再読み込み
please:
  confirm:
    answers: よければ回答を確定してください。
  close:
    window: この画面は閉じてください。
  select:
    one: 一つ選択してください。
  enter:
    answer: 回答を入力してください。
  change:
    answers: 回答し直す場合、「前へ戻る」で回答を修正してください。

report:
  tutorial:
    title:
      1: エンゲージメントとは
      2: エンゲージメント診断 TERASの見方
      3: エンゲージメントステータスとは
      4: エンゲージメント262とは
      5: エンゲージメントにつながる意識
      6: エンゲージメントを高める8つの項目
    description:
      1: エンゲージメントとは、「会社と従業員」及び「従業員同士」の相互信頼です。
         重要なのは、「会社と従業員」というタテと「従業員同士」というヨコの両方の信頼関係があることです
         組織として「持続可能なエンゲージメント」を高め、それを経営の軸にすることがエンゲージメント経営です。
      2: TERASは下記の項目で構成されています。
      3: 推奨、信頼、愛着、帰属の４つの意識から算出したものが、エンゲージメントステータスです。組織のエンゲージメント状態を可視化した指標です。
      4: 組織におけるエンゲージメントの構成状態です。組織のエンゲージメント状態の可視化をするために、組織を3分割した割合です。
      5: エンゲージメント（相互信頼関係）を高める上で必要な意識です。
      6: エンゲージメントに影響する要素となる組織内における8つの項目です。それぞれの項目での課題を導きだすために活用します。

policy:
  provisions:
    title: TERASにおける個人情報の取扱いについて
    outline:
      株式会社スタメン（以下、「当社」といいます。）は、
      提供するサービス（以下、「本サービス」といいます。）におけるプライバシー情報の取扱いについて、
      個人情報保護に関する法令及び国が定める指針その他の規範を遵守するとともに、
      プライバシーポリシー及び、以下の個人情報の取扱い（以下、「本規定」といいます。）に従い、適切な取扱い及び保護に努めます。
    section1:
      title: 第1条（プライバシー情報）
      body:
        1: プライバシー情報のうち「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報を指します。
        2: プライバシー情報のうち「履歴情報および特性情報」とは、上記に定める「個人情報」以外のものをいい、ご利用いただいたサービス、ご覧になったページ、ユーザーが検索された検索キーワード、ご利用日時、ご利用の方法、ご利用環境、郵便番号や性別、職業、年齢、ユーザーのIPアドレス、クッキー情報、位置情報、端末の個体識別情報などを指します。
    section2:
      title: 第2条（プライバシー情報の収集方法）
      body:
        1: 当社は、ユーザーが本サービスを利用する際に氏名、生年月日、住所、電話番号、メールアドレス、などの個人情報をお尋ねすることがあります。
        2: また、当社は、本サービス又は当社ウェブサイトの利用者の動向を統計的に調査する為、ユーザーについて、利用したサービス、閲覧したページの履歴、検索した検索キーワード、利用日時、利用方法、利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態、利用に際しての各種設定情報なども含みます）、IPアドレス、クッキー情報、位置情報、端末の個体識別情報などの履歴情報および特性情報を、ユーザーが当社や提携先のサービスを利用しまたはページを閲覧する際に収集します。
    section3:
      title: 第3条（個人情報を利用する目的）
      body:
        1: 当社が個人情報を利用する目的は、以下のとおりです。
        1-1: 本サービスの提供のため
        1-2: 各種画面におけるユーザーの登録情報の自動表示
        1-3: ご意見・ご質問等、各種問い合わせに対する回答
        1-4: 本サービスに関するキャンペーン、アンケート等のお知らせや連絡
        1-5: ユーザーの指示に基づく他のサービスへの転送
        1-6: 本サービスに関する統計情報の作成及び利用
        1-7: 上記の利用目的に付随する目的
        2: 当社は、個人情報保護法その他の法令により許容される場合を除き、
           本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取扱いません。
           当社は、秘密情報として特定した情報を利用する場合には当該利用が利用目的の範囲内であるかを判断するものとします。
           但し、次の場合はこの限りではありません。
        2-1: 法令に基づく場合
        2-2: 人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
        2-3: 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
        2-4: 国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
             本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
        3: 当社は、個人情報の利用目的を関連性を有すると合理的に認められる範囲内において変更することがあり、
           変更した場合には個人情報の主体である個人（以下「本人」といいます。）に通知し又は公表します。
    section4:
      title: 第4条（個人情報の適切な取得）
      body:
        1: 当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
        2: 当社は、次の場合を除き、あらかじめ本人の同意を得ないで、要配慮個人情報（個人情報保護法に定義されるものを意味します。）を取得しません。
        2-1: 第3条第2項各号のいずれかに該当する場合
        2-2: 当該要配慮個人情報が、本人、国の機関、地方公共団体、個人情報保護法第76条第1項各号に掲げる者その他個人情報保護委員会規則で定める者により公開されている場合
        2-3: 本人を目視し、又は撮影することにより、その外形上明らかな要配慮個人情報を取得する場合
        2-4: 第6条第2項各号によって第三者提供にあたらないものとされる態様にて要配慮個人情報の提供を受ける場合
        3: 当社は、第三者から個人情報の提供を受けるに際しては、個人情報保護委員会規則で定めるところにより、次に掲げる事項の確認を行います。
           ただし、当該個人情報の提供が第3条第2項各号のいずれかに該当する場合又は第6条第2項各号によって第三者提供にあたらないものとされる態様でなされる場合を除きます。
        3-1: 該第三者の氏名又は名称及び住所、並びに法人の場合はその代表者（法人でない団体で代表者又は管理人の定めのあるものの場合は、その代表者又は管理人）の氏名
        3-2: 当該第三者による当該個人情報の取得の経緯
    section5:
      title: 第5条（個人情報の安全管理）
      body: 当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。
            また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
    section6:
      title: 第6条（個人情報の第三者提供）
      body:
        1: ユーザーが本サービスを利用する場合は、ユーザーは次の事項に同意したものとします。
        1-1: 当社がユーザーから提供を受けた個人情報について、ユーザーが本サービスのメニューを利用するにあたり、当社が当該メニューの提供者に対して提供すること
        2: 当社は、前項の場合を除き、次に掲げる場合のほかは、あらかじめ本人の同意をえることなく、第三者に個人情報を提供することはありません。
        2-1: 法令に基づく場合
        2-2: 人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
        2-3: 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
        2-4: 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
             本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
        2-5: 予め次の事項を告知あるいは公表をしている場合
        2-5-1: 利用目的に第三者への提供を含むこと
        2-5-2: 第三者に提供されるデータの項目
        2-5-3: 第三者への提供の手段または方法
        2-5-4: 本人の求めに応じて個人情報の第三者への提供を停止すること
        3: 前項の定めにかかわらず、次に掲げる場合は第三者には該当しないものとします。
        3-1: 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
        3-2: 合併その他の事由による事業の承継に伴って個人情報が提供される場合
        3-3: 個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、
             共同して利用する者の範囲、利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について、
             あらかじめ本人に通知し、または本人が容易に知り得る状態に置いているとき
        4: 第2項各号の定めにかかわらず、当社は、第3条第2項各号のいずれかに該当する場合を除くほか、
           外国（個人情報保護法第24条に基づき個人情報保護委員会規則で指定される国を除きます。）
           にある第三者（個人情報保護法第24条に基づき個人情報保護委員会規則で指定される基準に適合する体制を整備している者を除きます。）に
           個人情報を提供する場合には、あらかじめ外国にある第三者への提供を認める旨の本人の同意を得るものとします。
        5: 当社は、個人情報を第三者に提供したときは、個人情報保護法第25条に従い、記録の作成及び保存を行います。
        6: 当社は、第三者から個人情報の提供を受ける場合には、個人情報保護法第26条に従い、必要な確認を行い、当該確認にかかる記録の作成及び保存を行うものとします。
    section7:
      title: 第7条（個人情報の開示）
      body:
        1: 当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。
           ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、
           開示しない決定をした場合には、その旨を遅滞なく通知します。
        1-1: 本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
        1-2: 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
        1-3: その他法令に違反することとなる場合
        2: 前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。
    section8:
      title: 第8条（匿名加工情報の取扱い）
      body:
        1: 当社は、匿名加工情報（個人情報保護法第2条第9項に定めるものを意味し、同法第2条第10項に定める匿名加工情報データベース等を構成するものに限ります。以下同じ。）を作成するときは、
           個人情報保護委員会規則で定める基準に従い、個人情報を加工するものとします。
        2: 当社は、匿名加工情報を作成したときは、個人情報保護委員会規則で定める基準に従い、安全管理のための措置を講じます。
        3: 当社は、匿名加工情報を作成したときは、個人情報保護委員会規則で定めるところにより、当該匿名加工情報に含まれる個人に関する情報の項目を公表します。
           なお、既に作成している匿名加工情報に関する情報の項目は、以下に記載のとおりです。
           また、当社は継続的な匿名加工情報の作成を予定しており、かかる情報の項目は、当社が異なる内容を公表する場合を除き、今後作成する匿名加工情報にもあてはまるものとします。
        4: 当社は、匿名加工情報（当社が作成したもの及び第三者から提供を受けたものを含みます。以下別段の定めがない限り同様とします。）を第三者に提供するときは、
           個人情報保護委員会規則で定めるところにより、あらかじめ、第三者に提供される匿名加工情報に含まれる個人に関する情報の項目及びその提供の方法について公表するとともに、
           当該第三者に対して、当該提供に係る情報が匿名加工情報である旨を明示します。
           なお、既に提供している匿名加工情報に関する情報の項目及び提供方法は、以下に記載のとおりです。
           また、当社は継続的な匿名加工情報の提供を予定しており、かかる情報の項目及び提供方法は、当社が異なる内容を公表する場合を除き、今後提供する匿名加工情報にもあてはまるものとします。
        5: 当社は、匿名加工情報を取り扱うに当たっては、匿名加工情報の作成に用いられた個人情報に係る本人を識別するために、
           (1) 匿名加工情報を他の情報と照合すること、及び (2) 当該個人情報から削除された記述等若しくは個人識別符号又は個人情報保護法第36条第1項の規定により行われた加工の方法に関する情報を取得すること
          （(2) は第三者から提供を受けた当該匿名加工情報についてのみ）を行わないものとします。
        6: 当社は、匿名加工情報の安全管理のために必要かつ適切な措置、匿名加工情報の作成その他の取扱いに関する苦情の処理その他の匿名加工情報の適正な取扱いを確保するために 必要な措置を自ら講じ、
          かつ、当該措置の内容を公表するよう努めるものとします。
        info: '匿名加工情報に含まれる情報の項目: 居住都道府県、年齢、性別'
    section9:
      title: 第9条（個人情報の訂正および削除）
      body:
        1: ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正または削除を請求することができます。
        2: 当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正または削除を行い、これをユーザーに通知します。
    section10:
      title: 第10条（本規定の変更）
      body: 当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本規定を変更します。
            重要な変更がある場合には、本サービス上などで分かりやすい方法でお知らせします。
            当社が別途定める場合を除いて、変更後の本規定は、本ウェブサイトに掲載したときから効力を生じるものとします。
    section11:
      title: 第11条（お問い合わせ窓口）
      body: 本規定に関するお問い合わせは、下記の窓口までお願いいたします。

  contact:
    title: 個人情報問い合わせ窓口
    provider: '事業者:'
    stmn_inc: 株式会社スタメン
    address: '住所:'
    office_address: 〒453-0012 愛知県名古屋市中村区井深町1-1
    phone_number: '電話:'
    office_phone_number: 052-462-1450
    mail: 'メール:'
    office_mail: privacy@stmn.co.jp

  established: '制定日: 2020年3月2日'
#  amended: '改訂日: 20**年*月*日'


